import React from 'react'
import Corporate from '../../../components/icons/Corporate'
import Institute from '../../../components/icons/Institute'
import StudentsIcon from '../../../components/icons/StudentsIcon'
import ActiveUsers from '../../../components/icons/ActiveUsers'

export const getAdminCardData = adminMetrics => {
  return [
    {
      key: 1,
      icon: <Corporate />,
      text: 'Corporates',
      totalValue: adminMetrics?.totalCorporates || 0,
      activeValue: adminMetrics?.activeCorporates || 0,
      color: '#1890ff',
    },
    {
      key: 2,
      icon: <Institute />,
      text: 'Institutes',
      totalValue: adminMetrics?.totalInstitutes || 0,
      activeValue: adminMetrics?.activeInstitutes || 0,
      color: '#52c41a',
    },
    {
      key: 3,
      icon: <StudentsIcon />,
      text: 'Students',
      totalValue: adminMetrics?.totalActiveStudents || 0,
      activeValue: adminMetrics?.activeStudents || 0,
      color: '#722ed1',
    },
    {
      key: 4,
      icon: <ActiveUsers />,
      text: 'Admin',
      totalValue: adminMetrics?.totalAdmins || 0,
      activeValue: adminMetrics?.activeAdmins || 0,
      color: '#fa8c16',
    },
  ]
}
